import { WORKSITE_STATUS_CHOICES } from "./constants";

export const getDateOfISOWeek = (weekNumber, year) => {
  // given week number and year, return a Date object
  // with day as the first day of the week
  let simple = new Date(year, 0, 1 + (weekNumber - 1) * 7);
  let dow = simple.getDay();
  let ISOweekStart = simple;
  if (dow <= 4)
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
  else
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
  return ISOweekStart;
}

export const get_current_status = (intl, statusObj) => {
  const active_status = Object.values(statusObj).filter(i => i.flg_active).reverse()
  return active_status.length && intl.formatMessage({id: active_status[0]['step']})
}

export const get_current_status_code = (statusObj) => {
  return Object.values(statusObj).filter(i => i.flg_active).slice(-1)[0]?.step;
}

export const set_worksite_status = (cod_worksite_status, selectedStep, userData, reason="") => {
  return Object.entries(cod_worksite_status)
    .filter(([_, step]) => WORKSITE_STATUS_CHOICES.includes(step.step)) // exclude possibly deprecated steps
    .reduce((prev, [key, step]) => {
      const mustModifyStep =
        step.id ===
        (selectedStep.id ||
          (step.id === selectedStep.id && !step.flg_active));
      return {
        ...prev,
        [key]: {
          ...step,
          date: mustModifyStep
            ? Math.floor(Date.now() / 1000) // now as unix epoch
            : step.date,
          reason: mustModifyStep ? reason : step.reason,
          author: mustModifyStep
            ? `${userData.firstname} ${userData.lastname}`
            : step.author,
          flg_active: step.id <= selectedStep.id,
        },
      };
    }, {});
}

export const compute_distance = (worksites) => {


  let latitude_diff = (Math.max.apply(Math, worksites.map(function (o) {
    return o.latitude;
  })) - Math.min.apply(Math, worksites.map(function (o) {
    return o.latitude;
  }))) ** 2
  let longitude_diff = (Math.max.apply(Math, worksites.map(function (o) {
    return o.longitude;
  })) - Math.min.apply(Math, worksites.map(function (o) {
    return o.longitude;
  }))) ** 2

  return (latitude_diff + longitude_diff) ** 0.5


}

export const compute_zoom = (distance) => {
  let zoom

  if (distance <= 0.05) {
    zoom = 13.00
  } else if (distance <= 0.1) {
    zoom = 11.00
  } else if (distance <= 0.2) {
    zoom = 10.50
  } else if (distance <= 0.3) {
    zoom = 9.50
  } else if (distance <= 0.5) {
    zoom = 9.25
  } else if (distance <= 0.6) {
    zoom = 9
  } else if (distance <= 0.7) {
    zoom = 8.5
  } else if (distance <= 1) {
    zoom = 8
  } else if (distance <= 1.5) {
    zoom = 7
  } else if (distance <= 2) {
    zoom = 6
  } else {
    zoom = 5
  }

  return zoom


}

//TODO: modify here
export function getUserVisibilityLevel(userData) {
  if (userData.role_type === 'progettista') {
    return 3
  } else if (userData.role_type === 'agente') {
    return 2
  } else {
    return 1
  }
}


export function filterTripletsByUserLevel(triplets, userData) {
  return triplets.filter(function (item) {
    return getUserVisibilityLevel(userData) <= item['riservato_kerakoll']
  })

}


export const getPDF = (
    intl,
    push,
    requestIssuer,
    url,
    payload,
    filepath,
    onSuccess=()=>{},
    onError=() => {},
    download=false
) => {
  return requestIssuer
    .post(url, payload, {responseType: "blob"})
    .then((response) => {
      let url = URL.createObjectURL(response);
      let link = document.createElement("a");
      link.href = url;
      if (download)
        link.download = filepath;
      else
        link.target = '_blank';
      link.click();
      onSuccess();
    })
    .catch((e) => {
      console.error(e)
      push({type: "error", title: intl.formatMessage({id: 'an_error_occurred'})});
      onError();
    })
}